import { render, staticRenderFns } from "./Ic_loader.vue?vue&type=template&id=7fa3859e&"
import script from "./Ic_loader.vue?vue&type=script&lang=js&"
export * from "./Ic_loader.vue?vue&type=script&lang=js&"
import style0 from "./Ic_loader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports